// extracted by mini-css-extract-plugin
export var legendIndicator = "_bf-1";
export var legendRight = "_bf-0";